export class EcwidImageModel implements EcwidImageModelProps {
  id: number;
  type: string;
  attributes: any;

  constructor(data: EcwidImageModelProps) {
    this.id = data.id;
    this.type = data.type;
    this.attributes = data.attributes;
  }

  static fromApi(data: any) {
    return ({
      id: data.id,
      type: data.type,
      attributes: data.attributes
    });
  }

  static empty() {
    return new EcwidImageModel({
      id: null,
      type: null,
      attributes: null
    });
  }
}

export interface EcwidImageModelProps {
    id: number;
    type: string;
    attributes: [];
}
